const mutations = {
	setBreadArray(state, data) {
		state.breadArray = data;
	},
	setUserInfo(state, data) {
		state.userInfo = data;
	}
};

export default mutations;